import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ManageAppsRaw = React.lazy(() => import(/* webpackChunkName: "ManageClientApps" */ './ManageApps'));
export const ManageApps = () => (React.createElement(Page, { title: "Manage Appearances", description: "Manage Appearances" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ManageAppsRaw, null)))));
